<template>
  <!-- BEGIN Page Header -->
  <div>
    <div :class="ismask ? 'black' : ''" @click="closeMask"></div>
    <header class="view_header">
      <div class="header-box">
        <!-- 头部左边 -->
        <div class="header-left">

          <div class="zxb-logo-box">
            <img src="../assets/img/logo.jpg">
            <span>展小帮</span>
          </div>
        </div>
        <div class="header-rigth">
          <ul>
            <li><a :class="{ 'active': active == 1 }" @click="scrollTo('/', 1)">产品介绍</a></li>
            <li><a :class="{ 'active': active == 2 }" @click="scrollTo('/extension', 2)">朋友圈推广</a></li>
            <li><a :class="{ 'active': active == 3 }" @click="scrollTo('/ExhibitClass', 3)">合作展会</a></li>
            <li><a :class="{ 'active': active == 4 }" @click="scrollTo('/ExhibitPrice', 4)">服务价格</a></li>
          </ul>
          <div class="denglu">
            <div class="login_button" @click="clickLogin">登录</div>
            <div class="call_button" @click="clickcall">联系我们</div>
          </div>
        </div>

      </div>

    </header>
    <div class="model" v-if="showModel == 2">
      <div class="model-box">
        <div class="close" @click="showModel = null">×</div>
        <div class="title">登录账号</div>
        <div class="subtitle">手机号登录</div>
        <div class="form-group i-mobile">
          <input type="text" class="form-control form-control-lg" placeholder="请输入手机号" v-model="mobile" required />
        </div>
        <div class="form-group" style="width: 300px;margin: 0 auto 16px;">
          <div class="d-flex align-items-center justify-content-between">
            <label class="form-label" for="username">图形验证码</label>
            <label @click="getimgcaptcha()" class="form-label" style="text-decoration: underline;color:#2196F3"
              for="username"><span class="fa fa-undo mr-1"></span>刷新一下</label>
          </div>
          <div class="d-flex row mr-0 ml-0 align-items-center justify-content-between">
            <input type="text" class="form-control  form-control-lg" placeholder="请输入图形验证码" v-model="captcha" required
              style="background: #f5f5f5;width: 200px;" />
            <img width="100" height="48" :src="'data:image/jpeg;base64,' + validImage" />
          </div>
        </div>
        <div class="form-group i-logon-code" style="margin-bottom: 26px;">
          <label class="form-label" for="password">收到的验证码</label>
          <div class="mr-0 ml-0  d-flex justify-content-between row">
            <input type="text" class="form-control form-control-lg" placeholder="请输入验证码" v-model="inputMsgCode"
              required />
            <button @click="sendCodeMsg" id="btn_GetVCode" type="button"
              class="col-4 btn btn-xs btn-info waves-effect waves-themed">
              发送验证码
            </button>
          </div>
        </div>
        <!-- <div class="forget" @click="showModel=4">忘记密码</div> -->
        <div class="login" @click="submitForm">登录</div>
        <!-- <div class="no-id">没有账号？<span @click="showModel=3">注册</span></div> -->
      </div>
    </div>
    <!-- 免费咨询弹窗 -->
    <div class="model2">
      <div class="model-box" v-if="isshow">
        <div class="name">
          <img src="../assets/img/person.jpg" alt="">
          <div class="name_con">
            <h4>添加展小帮产品顾问</h4>
            <p>享受一站式客服服务</p>
          </div>
        </div>
        <div class="wx-QR">
          <img src="../assets/img/qrcode.png" />
        </div>
        <div class="mobile">联系电话：18652557795</div>

      </div>
      <div class="service" @click="changePer">
        <div class="wxper">
          <img src="../assets/img/callper.png" alt="">
          <span>微信咨询</span>
        </div>
        <div class="callus">
          <img src="../assets/img/位图.png" alt="">
          <span>联系我们</span>
        </div>
      </div>
    </div>




    <div class="index myindex" @click="clickcall" v-if="isbanner">
      <!-- 轮播图 -->
      <!-- Swiper -->
      <div class="swiper-container1" v-if="banners.length > 1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, i) in banners" :key="i">
            <img :src="item.pic" />
          </div>

        </div>
        <!-- <div class="swiper-pagination1"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->

      </div>
      <div class="banner"  v-else>
        <img :src="banners[0].pic" alt="">
      </div>
    </div>
    <div class="mask" v-if="ismask">
      <img src="../assets/img/mask.png" alt="">
    </div>

  </div>


  <!-- END Page Header -->
</template>

<script>
import appsettings from "../utils/appsettings";
import selectExi from "../components/selectExi";
import { login, fetch } from "../utils/request";
import Swiper from "swiper";
export default {
  props: ['isbanner', 'active'],
  data() {
    return {
      ismask: false,
      appsettings: appsettings,
      userInfo: {},
      banners: [{ pic: require('@/assets/img/banner1.png') },
      ],
      showModel: '',

      mobile: "",
      inputMsgCode: "", //用户输入的短信验证码
      validImage: "", //接口返回的图形验证码
      validCode: "", //接口返回的图形验证码code
      captcha: "", //用户输入的图形验证码
      hasSend: false,
      totalcount: 120,
      swiper: '',
      isshow: false
    };
  },
  components: {
    selectExi,
    Swiper
  },
  computed: {
    showSelect() {
      return this.$store.state.showSelect
    },
  },
  created() {
    // 获取图形验证码
    this.getimgcaptcha();
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo;
    this.myswiper()

  },
  methods: {
    closeMask() {
      this.ismask = false
    },
    myswiper() {
      console.log('0000000');
      this.swiper = new Swiper('.swiper-container1', {
        // pagination: {
        //     el: '.swiper-pagination1',
        //     clickable: true,
        //   },

        loop: true, // 循环模式选项
        autoplay: {
          delay: 5000,

          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      });
    },
    clickLogin() {
      console.log("检查登录");
      fetch("post", "/account/checklogin", {})
        .then(res => {
          console.log("status:" + res.status);
          if (res.status == 0) {
            //登陆成功后保存token，获取用户信息以及设置用户侧边menu
            this.$router.push("/exiList");
          } else if (res.status == 1) {
            this.showModel = 2
          }
          else {
            this.$message.error(res.message);
            this.getimgcaptcha();
          }
        })
        .catch(err => {
          console.log("message:" + err.message);
          this.$message.error(err.message);
        });

    },
    changePer() {
      this.isshow = !this.isshow
    },
    // 获取图像验证码
    getimgcaptcha() {
      fetch("post", "/utility/imgcaptcha")
        .then(res => {
          if (res.status == 0) {

            this.validImage = res.data.image;
            this.validCode = res.data.code;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //发送验证码
    sendCodeMsg() {
      if (this.totalcount > 0 && this.hasSend) {
        return;
      }
      //校验随机验证码
      if (this.mobile == undefined || this.mobile.length == 0) {
        this.$message.warning("手机号不正确");
        return;
      }
      if (this.captcha == undefined || this.captcha.length == 0) {
        this.$message.warning("请输入图形验证码");
        return;
      }

      // 调用接口获得验证码
      fetch("post", "/utility/smsvalcode", { mobile: this.mobile, captcha: this.captcha, code: this.validCode })
        .then(res => {
          if (res.status == 0) {

            this.hasSend = true;
            this.beginCount();
          } else {
            this.$message.error(res.message);
            this.getimgcaptcha();
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    beginCount: function () {
      var that = this;
      this.interval = window.setInterval(function () {
        if (that.totalcount >= 0) {
          $("#btn_GetVCode").html(that.totalcount);
          that.totalcount--;
        } else {
          $("#btn_GetVCode").html("获取验证码");
          window.clearInterval(that.interval);
          that.interval = null;
          that.totalcount = 120;
          that.hasSend = false;
        }
      }, 1000);
    },
    submitForm() {
      login("post", "/account/login", { mobile: this.mobile, captcha: this.inputMsgCode })
        .then(res => {

          if (res.status == 0) {
            this.$store.dispatch("commitUpdateUserInfo", res.data);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            localStorage.setItem("token", res.data.token);
            //登陆成功后保存token，获取用户信息以及设置用户侧边menu
            this.$router.push("/exiList");
            // if (this.$route.query.goindex === "true") {
            //   this.$router.go(-1);
            // } else {
            //   this.$router.push("/");
            // }
          } else {
            this.$message.error(res.message);
            this.getimgcaptcha();
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    clickcall() {
      console.log('000000000000');
      this.ismask = true

    },
    scrollTo(val, num) {
      console.log(val, num);
      this.active = num
      this.$router.push({
        path: val
      })
    }

  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
html {
  font-size: 16px !important;
}

.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200
}

.mask {
  width: 393px;
  height: 704px;


  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  img {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }
}

.banner {
  width: 100%;
  height: auto;

  img {
    width: 100%;
    height: 100%;
  }
}

.swiper-container1 {
  margin-top: 35px;
  width: 100%;
 height: auto;

  .swiper-slide img {
    width: 100%;
    height: 100%;
  }

}

.view_header {
  width: 100%;
  background-color: #F7FBFF;
  position: fixed;
  top: 0;
  z-index: 10;

  .header-box {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    max-width: 1438px;
    margin: 0 auto;
    padding: 10px 5px;

    .header-left {
      display: flex;
      align-items: center;
      margin-right: 11px;

      .gyh-logo-box {
        width: 44px;
        height: 38px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .zxb-logo-box {
        display: flex;
        width: 116px;
        align-items: center;

        img {
          width: 38px;
          height: 28px;
          margin-right: 10px;
        }

        span {
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
        }
      }
    }

    .header-rigth {
      display: flex;
      width: 100%;
      justify-content: space-between;

      ul {
        margin: 0;
        width: 354px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        list-style: none;

        li {
          color: #000;
          font-family: PingFangSC-SNaNpxibold;
          font-weight: 600;
          font-size: 14px;

          a {
            cursor: pointer;
          }

          .active {
            color: #0088ff;
          }
        }

        li:last-child {
          margin-right: 0px;
        }
      }

      .denglu {
        color: #1A67DB;
        font-family: SourceHanSansCN-Medium;
        display: flex;
        align-items: center;
        font-size: 14px;
        .call_button {
          line-height: 1;
          border: 1px solid #1A67DB;
          border-radius: 4px;
          padding: 9px 20px;
          margin-left: 20px;
        }
        .login_button{
          line-height: 1;
          background-color: #1A67DB;
          color: #fff;
          border-radius: 4px;
          padding: 9px 20px;
         
        }
      }

      .zixun {
        cursor: pointer;
      }
    }

    .menu-icon {
      display: none;
    }
  }

}
.model {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  .model-box {
    width: 380px;
    height: 488px;
    background: #ffffff;
    box-shadow: 7px 4px 37px 1px rgba(107, 112, 128, 40%);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .name {
      text-align: center;
      margin: 65px 0 0;
      line-height: 20px;
      color: #101010;
      font-weight: bold;
    }
    .mobile {
      width: 158px;
      margin-left: 116px;
      margin-top: 36px;
      font-size: 14px;
      line-height: 14px;
      color: #101010;
    }
    .wx-id {
      width: 180px;
      margin-left: 115px;
      margin-top: 15px;
      font-size: 14px;
      line-height: 14px;
      color: #101010;
    }
    .wx-QR {
      width: 188px;
      height: 188px;
      margin: 20px auto;
      box-shadow: 0px 0px 18px 0px rgba(134, 143, 152, 0.4);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .confirm {
      width: 300px;
      height: 40px;
      margin: 28px auto 0;
      text-align: center;
      background: #0088ff;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
      border-radius: 20px;
    }
    .close {
      position: absolute;
      right: 27px;
      top: 27px;
      font-size: 26px;
      line-height: 18px;
      width: 18px;
      height: 18px;
      color: #7a7b7d;
      cursor: pointer;
    }
    .title {
      margin: 65px 0 47px 40px;
      color: #101010;
      font-size: 20px;
      line-height: 20px;
      font-weight: bold;
    }
    .subtitle {
      color: #101010;
      font-size: 14px;
      line-height: 14px;
      margin: 0 0 15px 40px;
    }
    .i-mobile {
      width: 300px;
      margin: 0 auto 16px;
      input {
        height: 40px;
        background: #f5f5f5;
      }
    }
    .i-password {
      width: 300px;
      margin: 0 auto 10px;
      input {
        height: 40px;
        background: #f5f5f5;
      }
    }
    .forget {
      text-align: right;
      padding: 0 40px;
      color: #9ca1a6;
      cursor: pointer;
      line-height: 15px;
      margin-bottom: 56px;
    }
    .login {
      width: 300px;
      height: 40px;
      background: #0088ff;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 14px;
      border-radius: 20px;
      margin: 0 auto 23px;
      cursor: pointer;
    }
    .no-id {
      text-align: center;
      color: #4e4e4e;
      font-size: 14px;
      line-height: 14px;
      span {
        cursor: pointer;
        color: #0088ff;
      }
    }
    .i-logon-mobile {
      width: 300px;
      margin: 0 auto 16px;
      span {
        display: inline-block;
        width: 48px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 2px;
        margin-right: 8px;
        color: #4e4e4e;
        font-size: 14px;
        text-align: center;
        padding-top: 10px;
      }
      input {
        width: 244px;
        height: 40px;
        background: #f5f5f5;
      }
    }
    .i-logon-code {
      width: 300px;
      margin: 0 auto 80px;
      input {
        width: 200px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 2px 0px 0px 2px;
      }
      button {
        width: 104px;
        height: 40px;
        border-radius: 0px 2px 2px 0px;
        background: #0088ff;
      }
    }
  }
  .forget-box {
    .title {
      margin-bottom: 76px !important;
    }
  }
  .update {
    .title {
      margin-bottom: 47px !important;
    }
    .mobile {
      font-size: 14px !important;
      line-height: 12px !important;
      margin: 0 0 16px 40px !important;
    }
    .i-password {
      margin-bottom: 16px;
    }
    .login {
      margin-top: 64px;
    }
  }
}
.model2 {
  position: fixed;
 
  right: 15px;
  top: 200px;
  z-index: 99;
  display: flex;

  .service {

    width: 85px;

    span {
      display: block;
      font-family: SourceHanSansCN-Medium;
      font-size: 12px;
      color: #0B5DD9;
     
      border-radius: 4px;
    }

    .wxper {
      margin-bottom: 20px;
      position: relative;
      img {
        width: 85px;
        height: 85px;
       
      }

      span {
        background: #EBF3FF;
        width: 64px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        position: absolute;
        top: 75px;
        left: 50%;
        transform: translateX(-50%);

      }

    }

    .callus {
     margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 64px;
      height: 59px;
      background: #EBF3FF;
      border-radius: 4px;

      img {
        margin-top: 12px;
        margin-bottom: 9px;
        width: 16px;
        height: 21px;
      }
    }
  }

  .model-box {
    width: 253px;
    height: 339px;
    box-sizing: border-box;
    padding: 19px 13px 27px 13px;
    background-color: #fff;
    border-radius: 4px;

    .name_con {
      margin-left: 10px;
    }

    .name {
      display: flex;
      font-family: SourceHanSansCN-Medium;

      h4 {

        font-weight: 500;
        font-size: 14px;
        color: #000000;
      }

      p {
        font-size: 12px;
        color: #979797;
        margin-bottom: 0;
      }

      img {
        width: 40px;
        height: 40px;

      }
    }

    .wx-QR {
      margin-top: 9px;

      img {
        width: 227px;
        height: 227px;

      }
    }

    .mobile {
      margin-left: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewHeader.vue